import React from 'react'
import { Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap'
import logo from '../../assets/images/acumenVelocityLogo.svg';
import { GrMail } from "react-icons/gr";
import { TiTick } from "react-icons/ti";
import './login.css'
import GoogleLoginButton from '../../components/buttons/googleLogin';
import { useNavigate, useParams } from 'react-router-dom';
import { FaInfoCircle } from 'react-icons/fa';

/**Login page */
const Login = () => {
    const navigate = useNavigate();
    let { id } = useParams();

    const renderTooltip = (props) => (
        <Tooltip id="info-tooltip" className="" {...props} >
            Gmail users Signup and Login using Google.<br />
            Other users, Signup and Login using email and password.<br />
            Note: Signup is enabled only for invited users.
        </Tooltip>
    );

    return (
        <div className='w-100 d-flex flex-column align-items-center gap-4' style={{ minHeight: '100vh', backgroundColor: '#e9eef7' }}>
            <div className='d-flex gap-2 justify-content-start align-items-center cursor_pointer w-100' style={{ height: '4rem' }} onClick={() => navigate('/')}>
                <Image alt='logo' src={logo} height={40} className='mx-1' />
                <p className='name fs_16 fw_700'>Acumen Translation Hub</p>
            </div>
            <div className='login d-flex w-100 justify-content-center px-3 px-md-0'>
                <div className='translation-hub-text-container mt-3 mt-md-5 d-flex flex-column flex-md-row gap-4 gap-md-0 bg-white' style={{ borderRadius: '5px' }}>
                    <div className='translation-hub-text mx-4'>
                        <p className='fn_Roboto text_title fs_28 fs_sm_18'>Acumen Translation Hub</p>
                        <p className='sub_title w-100 fs_16 fs_md_18 text-start mx-4'>Make your documents multilingual with a single click. Translate from one to many languages in a single step!</p>
                        <ul className="translation-hub-text-list mx-4">
                            <li className="bulleted-list-item">
                                <span><TiTick style={{ color: '#3995E7' }} /></span>
                                <span className="bulleted-list-text">Fast translation for PDF’s, Word and Powerpoints</span>
                            </li>
                            <li className="bulleted-list-item">
                                <span><TiTick style={{ color: '#3995E7' }} /></span>
                                <span className="bulleted-list-text">Full format retention</span>
                            </li>
                            <li className="bulleted-list-item">
                                <span><TiTick style={{ color: '#3995E7' }} /></span>
                                <span className="bulleted-list-text">Customize translations with your own models or use Google's Neural Machine Translation model</span>
                            </li>
                            <li className="bulleted-list-item">
                                <span><TiTick style={{ color: '#3995E7' }} /></span>
                                <span className="bulleted-list-text">Single, transparent pricing</span>
                            </li>
                        </ul>
                        <div className='mt-2 text-start mx-4'>
                            <h5 className='text_title fs_18'>Are you a new company?</h5>
                            <span className='text_title fs_16'>Create your company's account and join us today by </span>
                            <span
                                className='fs_14 text-primary cursor_pointer fs_16 fw_700'
                                style={{ textDecoration: 'underline' }}
                                onClick={() => navigate('/company/register')}>
                                Register here!
                            </span>
                        </div>
                    </div>
                    <div className='auth-container mt-3 mx-auto mx-md-5'>
                        <p className="fs_16 fw_600 text-black text_title">Sign in to Acumen Translation Hub</p>
                        <GoogleLoginButton />
                        <Button className='mt-4 color_white login_button' onClick={() => navigate(`${id ? `/email-login/${id}` : '/email-login'}`)}>
                            <GrMail style={{ color: '#fff', marginRight: "10%", width: '10%', height: '100%' }} />
                            Sign in with Email
                        </Button>
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip}
                        >
                            <div
                                className="w-100 "
                                style={{
                                    textAlign: "center",
                                    cursor: "pointer",
                                    height: 40,
                                    width: 20,
                                }}
                            >
                                <FaInfoCircle className='mt-3' style={{ cursor: 'pointer', color: '#3995E7' }} />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Login
